
import {Routes, Route, useParams, Link} from "react-router-dom";

import Header from "../../layouts/Header";
import Icon from "../../components/icon";
import Listing from "./Listing";
import Create from "./Create";
import Edit from "./Edit";



const PlanManager = () => {
    const {id} = useParams()

    return (
        <>
            <Header
                icon="plan"
                title="Plan Manager"
                buttons={[
                    !id && window.location.pathname !== '/plans/new' &&
                    <Link to={'new'} className="btn btn-sm btn-primary">
                        <Icon name="plus"/> <span>Create</span>
                    </Link>,
                ]}
            />
            <Routes>
                <Route index element={<Listing/>}/>
                <Route path="new" element={<Create/>}/>
                <Route path=":id" element={<Edit id={id}/>}/>
            </Routes>
        </>
    )
}

export default PlanManager